import { Router } from '@tanstack/react-router'

import { routeTree } from './routes'

export const router = new Router({
  routeTree,
  defaultPreload: 'intent',
  defaultPendingComponent: () => (
    <div className="flex items-center justify-center p-8">
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary"></div>
    </div>
  ),
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
